import React from 'react';
import { motion } from 'framer-motion';
import { Cabin } from '../types/cabin';
interface CabinCardProps {
  cabin: Cabin;
  onSelect: (id: string) => void;
  delay?: number;
}
export function CabinCard({
  cabin,
  onSelect,
  delay = 0
}: CabinCardProps) {
  return <motion.div initial={{
    opacity: 0,
    y: 35
  }} whileInView={{
    opacity: 1,
    y: 0
  }} viewport={{
    once: true,
    margin: '-40px'
  }} transition={{
    duration: 0.8,
    delay,
    ease: [0.25, 0.46, 0.45, 0.94]
  }} onClick={() => onSelect(cabin.id)} role="button" tabIndex={0} onKeyDown={e => {
    if (e.key === 'Enter') onSelect(cabin.id);
  }} className="group relative rounded-3xl overflow-hidden aspect-[16/10] sm:aspect-[3/4] cursor-pointer transition-transform duration-300 hover:-translate-y-1.5" data-id="element-32" data-mp="2dc5v8ujbmma4">
      <img src={cabin.image} alt={cabin.name} className="absolute inset-0 w-full h-full object-cover transition-transform duration-700 group-hover:scale-110" data-id="element-33" data-mp="1lm1fj96ianf8" />
      <div className="absolute inset-0 bg-gradient-to-t from-black/90 via-black/10 to-transparent group-hover:from-black/95 transition-all" data-id="element-34" data-mp="2qukxsb0ngmjt" />
      <div className="absolute bottom-0 left-0 right-0 p-5" data-id="element-35" data-mp="2lwjdjmrhmh6r">
        <p className="text-[0.67rem] text-gold-light tracking-[0.12em] uppercase mb-1" data-id="element-36" data-mp="2zuzmlkctojs2">{cabin.cardCaption}</p>
        <h3 className="font-display text-2xl font-light text-white mb-2" data-id="element-37" data-mp="2vr1n38jl56yh">{cabin.name}</h3>
        <span className="block text-[0.68rem] font-medium tracking-[0.1em] uppercase text-white/70 opacity-0 translate-y-2 transition-all duration-300 group-hover:opacity-100 group-hover:translate-y-0" data-id="element-38" data-mp="39r2xbelqpqqm">
          Ver cabaña →
        </span>
      </div>
    </motion.div>;
}